<template>
  <div class="list-top">
    <van-dropdown-menu class="dropdown-box" active-color="#4A79F1">
      <van-dropdown-item
        :value="dropdownValue"
        :options="dropdownOption"
        @change="dropdownChange"
      >
        <template #title>
          <div class="classify-btn">
            {{ dropdownlabel }}<img src="@/assets/img/mobileImg/arrow1.png" alt="" />
          </div>
        </template>
      </van-dropdown-item>
      <van-dropdown-item
        :value="dropdownValue1"
        :options="dropdownOption1"
        @change="dropdownChange1"
      >
        <template #title>
          <div class="classify-btn">
            <div>{{ dropdownlabel1 }}</div><img src="@/assets/img/mobileImg/arrow1.png" alt="" />
          </div>
        </template>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Icon } from "vant";
export default {
  components: {
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
  },
  props: {
    dropdownValue: {
      required: true,
      default: "0",
    },
    dropdownOption: {
      type: Array,
      required: true,
    },
    dropdownValue1: {
      required: true,
      default: "0",
    },
    dropdownOption1: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    dropdownlabel() {
      let str = ""
      this.dropdownOption.forEach(item => {
        if(item.value === this.dropdownValue) {
          str = item.text
        } 
      });
      return str
    },
    dropdownlabel1() {
      let str = ""
      this.dropdownOption1.forEach(item => {
        if(item.value === this.dropdownValue1) {
          str = item.text
        } 
      });
      return str
    },
  },
  methods: {
    dropdownChange(value) {
      this.$emit("getDropdownValue", value);
    },
    dropdownChange1(value) {
      this.$emit("getDropdownValue1", value);
    },
  },
};
</script>

<style scoped lang="scss">
.list-top {
  padding: 15px 12px 10px 12px;
  background-color: #F5F5F5;
  display: flex;
  justify-content: flex-start;
  .dropdown-box {
    position: relative;
    height: 30px;
    &::v-deep .van-dropdown-menu__bar {
      width: 100%;
      height: 100%;
      background-color: #F5F5F5;
      border-radius: 15px;
      box-shadow: none;
    }
    &::v-deep .van-dropdown-menu__title {
      max-width: 150px;
      padding: 0;

      &::after {
        content: none;
      }
    }
    &::v-deep .van-dropdown-item {
        top: 145px !important;
    }
  }
  .classify-btn {
    width: 98px;
    height: 30px;
    background: #ffffff;
    border-radius: 15px;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    > div {
      max-width: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    > img {
      width: 9px;
      height: 5px;
      margin-left: 8px;
    }
  }
}
</style>
